import { WK_UPLOADER } from './main';
import CosUploader from './cos';
import VodUploader from './vod';
import { WKWechatImageUploader } from './wechat';
export { WK_UPLOADER, CosUploader, VodUploader, WKWechatImageUploader as WX_UPLOADER };
export default WK_UPLOADER;


//////////////////
// WEBPACK FOOTER
// ./~/@weike/uploader/lib/esm/index.js
// module id = 642
// module chunks = 4